<template>
    <grid class="c-m g-m">
        <row class="c-m" :reverse="!1" end="xs" middle="xs">
            <column :xs="3">
                <i class="far fa-file-chart-line fa-3x"></i>
            </column>
            <column :xs="7">
                <input class="dock-pull-input" :placeholder="$t('reports.name_label')" :value="obj.report.name" type="text" @input="updateValue" name="name">
            </column>
            <column :xs="2"></column>
        </row>
        <row class="c-m" :reverse="!1" end="xs" middle="xs">
            <column :xs="3">
                <b>{{$t('reports.type_label')}}</b>
            </column>
            <column :xs="7">
                <label class="dock-pull-select-label">
                    <select class="dock-pull-select" name="type" :value="obj.report.type" @select="updateValue">
                        <option selected>{{$t('reports.type.points')}}</option>
                        <option>{{$t('reports.type.geo')}}</option>
                        <option>{{$t('reports.type.offline_days')}}</option>
                    </select>
                </label>
            </column>
            <column :xs="2"></column>
        </row>
        <row class="c-m" :reverse="!1" end="xs" middle="xs">
            <column :xs="3">
                <b>{{$t('reports.objects_label')}}</b>
            </column>
            <column :xs="7">
                <label class="dock-pull-select-label">
                    <select class="dock-pull-select">
                      <option v-bind:key="obj.id" v-for="obj in tree">{{obj.text}}</option>
                    </select>
                </label>
            </column>
            <column :xs="2"></column>
        </row>
        <row class="c-m" center="xs">
            <column :xs-offset="12">
                <button class="dock-pull-button">{{$t('reports.edit.delete_label')}}</button>
            </column>
        </row>
    </grid>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'Report',
  computed: {
    ...mapGetters(['getReport', 'treeRecycle']),
    tree () {
      // todo add tree select view
      return this.treeRecycle('', 'name', true)
    },
    obj () {
      return this.getReport(this.$route.params.id)
    }
  },
  methods: {
    ...mapMutations(['updateReport']),
    updateValue (e) {
      const report = this.obj.idx
      this.updateReport({
        idx: report,
        value: e.target.value,
        param: e.target.name
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/Report.vue